import axios from 'axios';
import { renderToString } from 'react-dom/server';
import React, { useEffect, useCallback } from 'react';
import MarqueeOptionsQuoteTable from '../components/marquee-options-quote-table';

let quoteSent = false;

export default function QuoteStep ({ quoteStep, quoteDetails, setQuoteDetails, zapierLink, thankYouPage }) {
	useEffect(() => {
		calculateQuote();
	}, [calculateQuote, quoteStep]);

	const calculateQuote = useCallback(() => {
		const marqueePrice = parseInt(quoteDetails.marquee.value);
		const optionsValues = quoteDetails.marqueeOptions.map(option => parseInt(option.value));
		const optionPrice = optionsValues.reduce((a, b) => a + b, 0);
		const totalPrice = marqueePrice + optionPrice + quoteDetails.distancePrice;
		const VATPrice = (totalPrice + totalPrice * 0.20).toFixed(2);

		setQuoteDetails({
			quoteId: `${quoteDetails.postcode}-${quoteDetails.lastName}-${quoteDetails.partyDate}`.toUpperCase(),
			price: totalPrice,
			VATPrice: VATPrice,
			priceSet: true
		});
	}, [quoteDetails, setQuoteDetails]);

	useEffect(() => {
		if (!quoteSent && quoteDetails.priceSet) {

			const finalQuote = {
				...quoteDetails,
				marqueeOptionsHTML: renderToString(<MarqueeOptionsQuoteTable quoteDetails={quoteDetails} />)
			}

			axios({
				method: 'post',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
				url: zapierLink,
				data: finalQuote
			}).then(res => {
				if (res.status === 200) {
					setTimeout(() => { window.location = thankYouPage }, 500);
				}
			})

			quoteSent = true;
		}
	}, [quoteDetails, thankYouPage, zapierLink]);

	return (
		<>
		</>
	)
}
